import * as Sentry from "@sentry/react";


// Duck-type check: .stack is optional since some SDK errors (e.g. PayMe) only expose .message
const isErrorObject = (obj) => obj && typeof obj.message === 'string' && obj.message
const tryToSafelyStringify = (obj) => {
    try {
        return JSON.stringify(obj)
    } catch (e) {
        return String(obj);
    }
}

export const ErrorService = {
    handleError(e, hint) {
        try {
            /* Ensure e is always a proper Error so Sentry can extract a meaningful title.
               Use duck-typing instead of instanceof to handle cross-realm errors (e.g. iframes).
               Guard against e.message being a non-string (e.g. PayMe plain objects). */
            const err = isErrorObject(e)
                ? e
                : new Error(typeof e?.message === 'string' && e.message ? e.message : tryToSafelyStringify(e) || 'Unknown error');

            /* Report to Sentry with optional context from hint.data */
            if (hint?.data) {
                Sentry.withScope((scope) => {
                    // Add structured tags for filtering in Sentry
                    Object.entries(hint.data).forEach(([key, value]) => {
                        if (value !== undefined && value !== null && typeof value !== 'object') {
                            scope.setTag(key, String(value))
                        } else if (value && typeof value === 'object') {
                            // Objects go as extra data (visible in Sentry "Additional Data")
                            scope.setExtra(key, value)
                        }
                    })
                    Sentry.captureException(err, hint)
                })
            } else {
                Sentry.captureException(err, hint)
            }
        } catch (veryBadError) {
            console.error(veryBadError);
        }
    }
}